export enum Color {
    DEFAULT = '_default',
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    EMPTY = 'empty',
    EMPTYALL = 'empty_all',
    TABBATTON = 'for_tab'
  }